import type {KnowledgeScope, LocationOptionDTO} from "../../../api/generated";
import {NewVehicleDataConfigurationDTOVehicleTypeEnum} from "../../../api/generated";

export type NewVehicleDataConfigurationRequest = {
    id?: number;
    isEnabled: boolean;
    vehicleType: NewVehicleDataConfigurationDTOVehicleTypeEnum;
    manufacturer?: string;
}

/**
 * The built-in knowledge types (platform KnowledgeType). The platform API exposes the type as a
 * plain string since admins can add their own, so the generated client has no enum for these.
 */
export enum BuiltInKnowledgeType {
    WARRANTY = "WARRANTY",
    FINANCE = "FINANCE",
    PART_EXCHANGE = "PART_EXCHANGE",
    SERVICE_AFTERSALES = "SERVICE_AFTERSALES",
    GENERAL_INFORMATION = "GENERAL_INFORMATION",
    MOTABILITY = "MOTABILITY",
    COMPLAINTS_AND_COMPLIANCE = "COMPLAINTS_AND_COMPLIANCE"
}

/** An attribute value on a knowledge record, as the platform returns it. */
export type KnowledgeRecordAttributeUi = {
    key: string;
    name: string;
    value: string;
}

/** An attribute value on a knowledge record, as the platform expects it on save. */
export type KnowledgeRecordAttributeRequest = {
    key: string;
    value: string;
}

/**
 * knowledgeType is a plain string: either a BuiltInKnowledgeType value or the key of a custom
 * knowledge type an admin defined.
 */
export type KnowledgeRecordUi = {
    id?: number;
    scope: KnowledgeScope;
    knowledgeType: string;
    content: string;
    attributes?: KnowledgeRecordAttributeUi[];
}

export type UpdateKnowledgeRecordRequest = {
    id?: number;
    knowledgeType: string;
    content: string;
    attributes: KnowledgeRecordAttributeRequest[];
}

export type FranchiseRequestUi = {
    id?: number;
    publicId: string;
    name: string;
    franchiseHash?: string;
    urlPathPattern?: string;
    focusEnabled: boolean;
    sharedWithFocusedFranchises: boolean;
    franchiseEmailConfigurationId?: number;
    franchiseEmailTranscriptRecipients: string;
    franchiseEmailFiltrationEnabled: boolean;
    franchiseEmailTranscriptSummaryEnabled: boolean;
    publicLocationIdList: LocationOptionDTO[];
    newVehicleDataConfiguration?: NewVehicleDataConfigurationRequest;
    knowledgeRecords?: KnowledgeRecordUi[];
}

export type FranchiseRequestApi = Omit<FranchiseRequestUi, "franchiseEmailTranscriptRecipients" | "publicLocationIdList"> & {
    franchiseEmailTranscriptRecipients: string[];
    publicLocationIdList: string[];
}

export const deriveLocationsFromFranchises = (franchiseList?: FranchiseRequestUi[]): LocationOptionDTO[] =>
    Array.from(new Map(
        (franchiseList || [])
            .flatMap(franchise => franchise.publicLocationIdList || [])
            .filter(location => !!location?.publicId)
            .map(location => [location.publicId, location])
    ).values());
